var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgResearchIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.2158 0C26.7155 0 24.052 14 24.052 14C29.3178 12.6962 38.5 13.2668 38.5 19.25V39.4012L30.0982 30.9995C30.9855 29.631 31.5 28 31.5 26.25C31.5 21.42 27.58 17.5 22.75 17.5C17.92 17.5 14 21.42 14 26.25C14 31.08 17.92 35 22.75 35C24.5648 35 26.25 34.447 27.6483 33.4985L36.1497 42H3.5V0H18.2158ZM22.75 21C25.648 21 28 23.352 28 26.25C28 29.148 25.648 31.5 22.75 31.5C19.852 31.5 17.5 29.148 17.5 26.25C17.5 23.352 19.852 21 22.75 21ZM25.494 0.13125C29.3457 2.18575 35.8855 8.67825 38.5 12.1747C36.2495 10.5997 31.423 9.275 27.8408 10.1097C28.2292 7.54075 27.5152 2.17525 25.494 0.13125Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResearchIcon);
export default __webpack_public_path__ + "static/media/researchIcon.a72bf1673f33b3f392cb880a37a251e0.svg";
export { ForwardRef as ReactComponent };